const uniqueTabAllList = document.querySelectorAll('.unique__tab-item')
uniqueTabAllList.forEach((item) => {
   var uniqueTabID = item.id;
  
  if (item.textContent === null || !item.textContent.trim()) {
    let uniqueTabList = item.parentElement.previousElementSibling.children;
    
    Object.values(uniqueTabList).forEach((sinitem) => {
      if('unique' in sinitem.dataset){
        if(sinitem.dataset.unique === uniqueTabID){
          sinitem.remove();
        };		
      }
    });
    item.remove();
  }
});

// 兜底：删除空的 unique_tab 后，如果没有任何激活项，则激活第一个仍然存在的 tab 及对应面板
document.querySelectorAll('.product_tab_list').forEach(function (tabList) {
  if (tabList.querySelector('[data-toggle="tab"].active')) return;
  var firstTab = tabList.querySelector('[data-toggle="tab"]');
  if (!firstTab) return;
  var target = document.querySelector(firstTab.getAttribute('data-target'));
  if (!target) return;
  firstTab.classList.add('active');
  target.classList.add('active', 'show');
});